import type { ExtensionPresence, LivePage, ReaderPresence } from './client';

// Pure merge of the per-reader presence under `/sync/{ownerId}/readers` into the
// single extension view the app/embed consumes: installed/online is true if ANY
// extension reader reports it, and the open live `pages` are unioned. Non-extension
// readers (bots, API pollers) share the collection but are ignored here — they carry
// no `installed`/`pages`. An untyped node is treated as an extension (backward-lenient
// during the rename). Kept Firebase-free so both the main-thread client (client.ts)
// and the SharedWorker (rtdb.worker.ts) can share it without pulling in firebase-service.
export const mergeExtensionReaders = (
  readers: Record<string, ReaderPresence>
): ExtensionPresence => {
  let installed = false;
  let online = false;
  const pages: Record<string, LivePage> = {};
  Object.values(readers || {}).forEach((reader) => {
    if ((reader?.type ?? 'extension') !== 'extension') return;
    if (reader?.installed) installed = true;
    if (reader?.online) online = true;
    Object.assign(pages, reader?.pages || {});
  });
  return { installed, online, pages };
};
